import { Dropdown, Button } from "react-bootstrap";
import { GearFill } from "react-bootstrap-icons";

export const CellActions = ({ buttons }) => {
  if (buttons.length === 0) {
    return null;
  }

  return (
    <>
      <Dropdown className="d-xl-none position-static">
        <Dropdown.Toggle variant="outline-secondary">
          <GearFill />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {buttons?.map((button, index) => (
            <Dropdown.Item key={index} onClick={() => button.action()}>
              <div className="d-flex align-items-center">
                {button.icon}
                <span className="me-2"></span>
                {button.title}
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <div className="d-none d-xl-block">
        {buttons?.map((button, index) => (
          <Button
            key={index}
            className="me-2"
            variant={`outline-${button.variant}`}
            title={button.title}
            onClick={() => button.action()}
          >
            {button.icon}
          </Button>
        ))}
      </div>
    </>
  );
};
